<!-- eslint-disable vue/no-mutating-props -->
<template>
  <component
    v-show="it.isShow !== undefined ? it.isShow : true"
    v-on="it.elConfig && it.elConfig.events && it.elConfig.events"
    v-bind="it.elConfig && it.elConfig"
    :required="(it.itemConfig && it.itemConfig.required) || false"
    :prop="it.itemConfig && it.itemConfig.prop"
    :label="it.itemConfig && it.itemConfig.label"
    v-model="model[it.itemConfig && it.itemConfig.prop]"
    v-if="it.elRender"
    :is="it.elRender"
  />
  <render-template
    v-show="it.isShow !== undefined ? it.isShow : true"
    :renderTemplate="it.render && it.render"
    v-else-if="typeof (it.render || '') === 'function'"
  />
  <component
    v-show="it.isShow !== undefined ? it.isShow : true"
    v-on="it.elConfig && it.elConfig.events && it.elConfig.events"
    v-bind="it.elConfig && it.elConfig"
    :required="(it.itemConfig && it.itemConfig.required) || false"
    :prop="it.itemConfig && it.itemConfig.prop"
    :label="it.itemConfig && it.itemConfig.label"
    :ref="it.itemConfig && it.itemConfig.ref"
    v-model="model[it.itemConfig && it.itemConfig.prop]"
    v-else-if="
      it.render &&
        ['[object String]', '[object Object]'].includes(
          Object.prototype.toString.call(it.render)
        )
    "
    :is="it.render"
  />
  <el-form-item
    v-show="it.isShow !== undefined ? it.isShow : true"
    v-else
    v-bind="it.itemConfig && it.itemConfig"
    v-on="it.itemConfig && it.itemConfig.events && it.itemConfig.events"
    :label-width="labelWidth"
  >
    <slot name="labelTip" />
    <render-template
      :renderTemplate="it.elConfig && it.elConfig.render && it.elConfig.render"
      v-if="typeof ((it.elConfig && it.elConfig.render) || '') === 'function'"
    />
    <component
      v-on="it.elConfig && it.elConfig.events && it.elConfig.events"
      v-bind="it.elConfig && it.elConfig"
      v-else-if="
        it.elConfig &&
          it.elConfig.render &&
          ['[object String]', '[object Object]'].includes(
            Object.prototype.toString.call(it.elConfig.render)
          )
      "
      :is="it.elConfig && it.elConfig.render"
      v-model="model[it.itemConfig && it.itemConfig.prop]"
    />
    <base-form-child
      v-else
      v-model.trim="model[it.itemConfig && it.itemConfig.prop]"
      :name="getElementItem(it.el)"
      v-bind="it.elConfig && it.elConfig"
      :on="it.elConfig && it.elConfig.events && it.elConfig.events"
      :attrs="getAttrs(it, 'attrs')"
      :props="getAttrs(it, 'props')"
      :directives="it.directives"
    >
      <!-- 下拉选项 -->
      <template v-if="it.el === 'select' && isShowEL(it)">
        <el-option
          v-for="option in it.elConfig.options.list"
          :key="`option${option[it.elConfig.options.value]}`"
          :label="
            it.elConfig.options.label
              ? getOptionAttr(option, it.elConfig.options.label)
              : option
          "
          :value="
            it.elConfig.options.value
              ? getOptionAttr(option, it.elConfig.options.value)
              : option
          "
          :disabled="option.disabled"
        >
          <div
            v-html="it.elConfig.elRender && it.elConfig.elRender(option)"
            v-if="typeof it.elConfig.elRender === 'function'"
          ></div>
          <div
            v-html="
              it.elConfig.options &&
                it.elConfig.options.slotElRender &&
                it.elConfig.options.slotElRender(option)
            "
            v-else-if="
              typeof (
                (it.elConfig.options &&
                  it.elConfig.options.slotElRender &&
                  it.elConfig.options.slotElRender) ||
                ''
              ) === 'function'
            "
          ></div>
          <jsx-template
            :jsxRender="it.elConfig.jsxRender && it.elConfig.jsxRender(option)"
            v-else-if="typeof (it.elConfig.jsxRender || '') === 'function'"
          />
          <render-template
            :option="option"
            :renderTemplate="
              it.elConfig &&
                it.elConfig.options &&
                it.elConfig.options.slotRender &&
                it.elConfig.options.slotRender
            "
            v-else-if="
              typeof (
                (it.elConfig &&
                  it.elConfig.options &&
                  it.elConfig.options.slotRender) ||
                ''
              ) === 'function'
            "
          />
          <component
            :option="option"
            v-else-if="
              it.elConfig.options.slotRender &&
                ['[object String]', '[object Object]'].includes(
                  Object.prototype.toString.call(it.elConfig.options.slotRender)
                )
            "
            :is="it.elConfig.options.slotRender"
          />
          <div v-else>
            {{
              it.elConfig.options.label
                ? getOptionAttr(option, it.elConfig.options.label)
                : option
            }}
          </div>
        </el-option>
      </template>
      <!-- 单选 -->
      <template v-else-if="it.el === 'radio' && isShowEL(it)">
        <el-radio
          v-for="(option, optionIdx) in it.elConfig.options.list"
          :key="'option' + optionIdx"
          :label="option[it.elConfig.options.value]"
          :disabled="it.itemConfig.disabled"
        >
          {{ option[it.elConfig.options.label] }}
        </el-radio>
      </template>
      <!-- 多选 -->
      <template v-else-if="it.el === 'checkbox' && isShowEL(it)">
        <el-checkbox
          v-for="(option, optionIdx) in it.elConfig.options.list"
          :key="'option' + optionIdx"
          :label="option[it.elConfig.options.value]"
          :disabled="
            option.hasOwnProperty('disabled') ? option.disabled : false
          "
        >
          {{ option[it.elConfig.options.label] }}
        </el-checkbox>
      </template>
      <!-- 所属部门选择框 -->
      <template v-else-if="it.el === 'DeptSelect'">
        <DeptSelect
          v-model="model[it.itemConfig && it.itemConfig.prop]"
          :multiple="it.elConfig.multiple"
          :isAll="it.elConfig.isAll"
        />
      </template>
    </base-form-child>
    <!-- 额外显示元素 -->
    <jsx-template
      v-if="it.extra && typeof (it.extra) === 'function'"
      :jsxRender="it.extra(model[it.itemConfig && it.itemConfig.prop])"
    />
  </el-form-item>
</template>

<script>
import BaseFormChild from './BaseFormChild'
import renderTemplate from './renderTemplate'
import jsxTemplate from './jsxTemplate'
import { optionDefault } from './config'

export default {
  name: 'FormItem',
  props: {
    it: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: Object,
      default: () => ({}),
    },
    labelWidth: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      optionDefault,
    }
  },
  components: {
    BaseFormChild,
    jsxTemplate,
    renderTemplate,
  },
  methods: {
    // 是否展示el元素（el-form-item内部element-ui元素select、checkbox、radio)
    isShowEL(it) {
      return it.elConfig && it.elConfig.options && it.elConfig.options.list
    },

    getElementItem(type) {
      if (type === 'radio') {
        return 'el-radio-group'
      }
      if (type === 'checkbox') {
        return 'el-checkbox-group'
      }
      if (type === 'QS-select') {
        return 'QS-select'
      }
      if (type === 'DeptSelect') {
        return 'DeptSelect'
      }
      return `el-${type || 'input'}`
    },

    // 获取原生attrs
    getNativeAttrs(elConfig) {
      const {
        name = '',
        alt = '',
        maxlength = '',
        minlength = '',
        autoComplete = 'off',
        readonly = false,
        max = Infinity,
        min = -Infinity,
        step = 1,
        autofocus = false,
        form,
        nativeType = 'button',
        referrerPolicy = '',
      } = elConfig
      return {
        name,
        alt,
        maxlength,
        minlength,
        'auto-complete': autoComplete,
        readonly,
        max,
        min,
        step,
        autofocus,
        form,
        'native-type': nativeType,
        'referrer-policy': referrerPolicy,
        ...elConfig,
      }
    },

    // 获取element-ui元素的属性，包含attrs和props
    getAttrs(it, type) {
      // eslint-disable-next-line no-shadow
      const { optionDefault, getNativeAttrs } = this
      const { el, elConfig = {} } = it
      return Object.assign(
        {},
        optionDefault[el || 'input'] &&
          optionDefault[it.el || 'input'][type] &&
          optionDefault[it.el || 'input'][type],
        getNativeAttrs(elConfig),
      )
    },

    // 兼容 option 为 undefined 控制台 error
    getOptionAttr(option, key) {
      if (!option) {
        return ''
      }
      return option[key]
    },
  },
}
</script>

<style></style>
